<template>
    <div class="guide-container">
        <div class="content-woori">
            <div class="guide-header">
                <img
                    class="img-logo"
                    src="@/assets/images/woori/card/mzxwooricard.png"
                >
                <p>메가존 클라우드<br/>제휴카드 신청 안내</p>
                <div>제휴카드로 결제 시 <span>0.5%</span>
                    <br/>포인트 적립 혜택을 드립니다.
                </div>
            </div>
            <b-card class="card-steps mb-0">
                <div class="d-flex align-items-center justify-content-center">
                    <div
                        class="card-step"
                    >
                        <div class="card-step-content">
                            <span>
                                STEP 1-1
                            </span>
                            <p>
                                우리카드 홈페이지에서
                                <br/>제휴카드를 신청하세요
                            </p>
                            <p class="card-step-content-note">
                                <span style="color: #847EF0; font-weight: 500;">주의 사항</span> 우리카드 홈페이지 내 카드 신청 시
                                보안 프로그램 설치하실 경우 메가존 클라우드 카드 신청 화면에서 카드 발급 재신청하시면 신청 가능합니다.
                            </p>
                        </div>

                        <div class="d-flex justify-content-between align-items-center">
                            <img
                                class="img-logo"
                                src="@/assets/images/woori/card/logo_wooricard.png"
                            >
                            <b-button
                                variant="primary"
                                class="card-step-button"
                                @click="goToWooriPageByCard"
                            >
                                신청하기
                            </b-button>
                        </div>
                    </div>
                    <div
                        style="width: 20px;"
                    >
                    </div>
                    <div
                        class="card-step"
                    >
                        <div class="card-step-content">
                            <span>
                                STEP 1-2
                            </span>
                            <p>
                                우리카드 모바일에서 간편신청
                                <br/>* 법인신규 대상
                            </p>
                        </div>
                        <div class="d-flex justify-content-center align-items-center">
                            <img
                                src="@/assets/images/woori/card/woori_card_qr.png"
                                style="width: 120px; height: 120px; cursor: pointer;"
                                @click="goToWooriMobilePage"
                            >
                        </div>
                    </div>
                    <div
                        class="card-steps-arrow"
                    >
                        <img src="@/assets/images/woori/card/arrow_next_step.png" alt="arrow_next_step">
                    </div>
                    <div
                        class="card-step"
                    >
                        <div class="card-step-content">
                            <span>
                                STEP 2
                            </span>
                            <p>
                                제휴카드를 하이퍼빌링의
                                <br/>Register Card 메뉴에 등록하세요
                            </p>
                        </div>
                        <div class="d-flex justify-content-between align-items-center">
                            <img
                                class="img-logo"
                                src="@/assets/images/woori/card/logo_mzcx2.png"
                            >
                            <b-button
                                variant="primary"
                                class="card-step-button"
                                @click="goToRegisterCard"
                            >
                                <router-link to="/register-card" class="text-white">신청하기</router-link>
                            </b-button>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center">
                    <div style="width: 940px;">
                        <p style="padding-top: 20px; padding-bottom: 8px; margin: 0; text-align: left;">
                            메가존클라우드 제휴 우리카드 전용 상담신청 : 02-6968-3413
                        </p>
                    </div>
                </div>
            </b-card>
            <b-card
                no-body
                class="card-tabs mb-0"
            >
                <b-tabs
                    class="card-tab"
                >
                    <b-tab title="제휴카드 신규발급 안내">
                        <div
                            class="text-center"
                            style="margin: 0 -24px -24px -24px;"
                            @click="goToWooriPageByBanner"
                        >
                            <img
                                src="@/assets/images/woori/card/woori_card_banner.png"
                                style="
                                    width: 100%;
                                    height: 100%;
                                    object-fit:
                                    contain; border-radius: 30px;
                                "
                            >
                            <!-- (우리카드 제작 영역 배너 사이즈 가로 670 x 세로 470) -->
                        </div>
                    </b-tab>
                    <b-tab title="하이퍼빌링 제휴카드 등록 안내">
                        <b-table
                            class="table-guide"
                            :items="items"
                            :fields="fields"
                        >
                            <template #cell(title)="data">
                                <div v-html="data.value"></div>
                            </template>
                            <template #cell(content)="data">
                                <div v-html="data.value"></div>
                            </template>
                        </b-table>
                    </b-tab>
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import useGTag from '@/composables/useGTag'
export default {
    data () {
        return {
            fields: [
                {
                    key: 'title',
                    thClass: ['d-none'],
                    tdClass: ['table-title']
                },
                {
                    key: 'content',
                    thClass: ['d-none'],
                    tdClass: ['table-content']
                }
            ],
            items: [
                {
                    title: '발급 대상',
                    content: '우리카드 발급 기준에 부합하는 법인사업자<br/>(공동/각자대표, 외국인대표, 미성년대표 비대면 신청불가)'
                },
                {
                    title: '대상 카드',
                    content: '메가존 클라우드 제휴신용 카드'
                },
                {
                    title: '신청 대상자',
                    content: '법인사업자의 대표자'
                },
                {
                    title: '신청 방법',
                    content: '우리카드 기업홈페이지 > 안내・신청 > 신규발급 > 신청하고자 하는 카드 상품 선택 > 사업자정보 입력 > 금소법 적합성 확인 > 고객정보확인 > 대표자정보 / 카드정보 / 결제정보 입력 > 신청정보 확인 > 신청완료 > FIND 시스템 서류자동제출'
                },
                {
                    title: '필요서류',
                    content: '&#8226; 사업자등록증, 법인등기사항전부증명서, 최근년도 재무제표, 주주명부 등<br/>&#8226; 해당 서류는 한국평가데이터 KODATA 시스템을 통해 제출하셔야 합니다.'
                },
                {
                    title: '유의사항',
                    content: '&#8226; 법인사업자 신규발급 시, 공용카드만 신청 가능합니다. (지정카드 신청 불가)<br/>&#8226; 외국회사법인, 비영리법인, 영리법인의 지점 등은 비대면 신규 발급 불가합니다.<br/>&#8226; 카드 신청 완료 후, FIND 시스템을 통한 서류제출 미완료시 카드 신청이 취소될 수 있습니다.<br/>&#8226; 발급심사에 필요한 부가 정보 및 추가 서류는 심사단계에서 추가 요청할 수 있습니다.'
                },
                {
                    title: '기업 신용카드<br/>연회비 안내',
                    content: '해외겸용(Mastercard) : 5,000원'
                },
                {
                    title: '관련문의',
                    content: '우리카드 고객센터 1588-9955 / 1599-9955'
                }
            ]
        }
    },
    methods: {
        goToWooriPageByCard: () => {
            // - Card > 신청하기  :  hb_new_card
            useGTag().trackEvent('hb_new_card')
            window.open('https://pc.wooricard.com/dcpc/yh2/bcd/bcd01/cdadv/H2BCD201S01.do?cdPrdCd=103717&rcmEmpNo=20395102', '_blank')
        },
        goToWooriPageByBanner: () => {
            // - Card > 우리카드 배너  : hb_card_banner
            useGTag().trackEvent('hb_wcard_banner')
            window.open('https://pc.wooricard.com/dcpc/yh2/bcd/bcd01/cdadv/H2BCD201S01.do?cdPrdCd=103717&rcmEmpNo=20395102', '_blank')
        },
        goToRegisterCard: () => {
            // - Register Card: hb_register_card
            useGTag().trackEvent('hb_register_card')
        },
        goToWooriMobilePage: () => {
            // - Card > QR 코드 클릭 : 모바일 페이지
            useGTag().trackEvent('hb_qr_code')
            window.open('https://m.wooricard.com/dcmw/yh2/bcd/bcd01/cdadv/M2BCD201S01.do?cdPrdCd=103717', '_blank')
        }
    }
}
</script>

<style>
.guide-container {
    overflow-x: auto;
    font-family: 'Pretendard', sans-serif;
}
.content-woori {
    font-family: 'Pretendard', sans-serif;
    background-color: #E1DBE7;
    width: 1200px;
    /* height: 1536px; */
    margin: auto;
    padding: 64px;
    background-image: linear-gradient(298.53deg, rgba(171, 174, 215, 0) 54.38%, #B4AFC9 109.47%, transparent), url('../assets/images/woori/card/guide_banner.png');
    background-repeat: no-repeat;
    background-size: contain;
    background-position: top, top;
}
.content-woori .guide-header {
    color: #ffffff;
    text-shadow: 1px 1px 15px #B9B4D9;
    margin-bottom: 110px;
}
.content-woori .guide-header .img-logo {
    width: 227.92px;
}
.content-woori .guide-header > p {
    font-weight: 700;
    font-size: 56px;
    line-height: 58px;
    letter-spacing: 0%;
    margin: 0;
    padding-top: 64px;
    padding-bottom: 45px;
}
.content-woori .guide-header > div {
    font-weight: 500;
    font-size: 32px;
    line-height: 40px;
    letter-spacing: 0%;
}
.content-woori .guide-header > div > span {
    color: #4B4959;
    font-weight: 800;
    font-size: 32px;
    line-height: 40px;
    letter-spacing: 0%;
}
.card-steps {
    border-radius: 30px;
}
.card-step {
    width: 280px;
    height: 273px;
    padding: 20px 24px;
    border: 1px solid #E1E1E3;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 14.7px;
}
.card-step .img-logo {
    width: 90.4px;
}
.card-step .card-step-content > span {
    font-size: 14px;
    color: #686A72;
    font-weight: 700;
    font-size: 14px;
    line-height: 100%;
}
.card-step .card-step-content > p {
    color: #222222;
    font-weight: 700;
    font-size: 16px;
    line-height: 140%;
    letter-spacing: -2%;
    margin-top: 15px;
}
.card-step  .card-step-content > p.card-step-content-note {
    color: #222222;
    font-weight: 300;
    font-size: 13px;
    line-height: 140%;
    letter-spacing: -2%;
}
.card-step .card-step-button {
    background-color: #847EF0 !important;
    border: #847EF0 !important;
    border-radius: 100px;
    font-size: 12px;
    height: 32px;
}
.card-steps-arrow {
    margin: 0 20px;
}
.card-tabs {
    border-radius: 30px;
    padding: 24px;
    margin-top: 24px;
}
.card-tab {
    font-size: 15px;
}
.nav-tabs {
    margin-bottom: 0;
}
.nav-tabs .nav-link:after {
    left: 0;
    background: #7367f0 !important;
}
.tab-content {
    padding: 24px;
}
/* table */
.table-guide {
    font-size: 13px;
    line-height: 140%;
    color: #898A8E;
}
.table-guide tr td:first-child {
    font-weight: 600;
    line-height: 120%;
}
.table-guide tr:first-child td {
    border-top: none;
}
.table-title {
    width: 110px;
    vertical-align: top !important;
    padding: 8px !important;
}
.table-content {
    padding: 8px !important;
}
</style>
